'use client';
import e$1 from 'prop-types';
import * as e from 'react';
import { createComponent } from '../core/create-component.js';
import { VisuallyHidden } from '../visually-hidden/visually-hidden.component.js';

let l = {
    visuallyHiddenLabel: e$1.node,
    accessibleText: e$1.string
};
const ZoomControlsValue = createComponent({
    displayName: 'ZoomControlsValue',
    root: 'span',
    propTypes: l,
    propConfig: {
        classNames: [
            'swan-zoom-controls-value'
        ],
        wrapChildren ({ accessibleText: e$1, visuallyHiddenLabel: r }, l, n) {
            let a = null != e$1 ? e$1 : r;
            return e.createElement(e.Fragment, null, a && e.createElement(VisuallyHidden, null, a), n);
        }
    }
});

export { ZoomControlsValue };
